import { Route } from "vue-router";

import listItemPageUrlParser from "@/lib/services/list-item-page-url-parser.function";

import FactoryRushCapacityManagementPage from "./components/ManagementPage.vue";
import FactoryRushCapacityEditPage from "./components/EditPage.vue";

export default [
  {
    path: "/factory_rush_capacity/manage",
    name: "FactoryRushCapacityManagementPage",
    component: FactoryRushCapacityManagementPage,
    meta: {
      auth: true,
    },
  },
  {
    path: "/factory_rush_capacity/edit",
    name: "FactoryRushCapacityEditPage",
    component: FactoryRushCapacityEditPage,
    props: (route: Route) => {
      const props = listItemPageUrlParser(route);

      if (typeof route.query.id === "string") {
        props["factoryId"] = route.query.id;
      }

      return props;
    },
    meta: {
      auth: true,
    },
  },
];
